import {
  Alert,
  Modal,
  ModalContent,
  ModalFooter,
  SearchInput,
  TextInput,
  useToaster
} from "@dealer-center/core-components";
import { useState } from "react";
import {
  useDealerCodesGetTypes,
  useMapDealerCodeTypeToAccount
} from "@dealer-center/ddc-pages-dealer-codes-fetch";
import { populateMappingConfig } from "./helper";
import {
  LoadingIndicator,
  SaveAndCancel
} from "@dealer-center/core-custom-components";
import { DuplicateDealerCodeValueWarning } from "./duplicate-dealer-code-value-warning";
interface DealerCodesAddDealerToCodeModalProps {
  accountId: string;
  show: boolean;
  close: () => void;
}
export const DealerCodesAddDealerToCodeModal = ({
  close,
  accountId,
  show
}: DealerCodesAddDealerToCodeModalProps) => {
  const [
    addDealerCodeToDealerInputString,
    setAddDealerCodeToDealerInputString
  ] = useState<string>("");
  const [selectedType, setSelectedType] = useState<string>("");

  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending } =
    useMapDealerCodeTypeToAccount();
  if (isError) {
    toastError(`Error adding dealer code to ${accountId}`);
    close();
  }
  if (isSuccess) {
    toastSuccess(
      "Success",
      `Dealer code ${addDealerCodeToDealerInputString} added to ${accountId}`
    );
    close();
  }

  const {
    data: dealercodesTypeList,
    isLoading,
    error
  } = useDealerCodesGetTypes();
  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Dealer Code Add dealer to code"
              isDisabled={{
                save:
                  addDealerCodeToDealerInputString === "" || selectedType === ""
              }}
              isSaving={isPending}
              saveButtonText="Add"
              onCancel={close}
              onSave={() => {
                const config = populateMappingConfig(
                  accountId,
                  addDealerCodeToDealerInputString,
                  selectedType
                );
                mutate(config);
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Add Dealer Code to ${accountId}`}
      show={show}
      size="small"
      onHide={close}
    >
      <ModalContent>
        {isLoading && (
          <LoadingIndicator actionName="Loading Dealer Code Types" />
        )}
        {error && (
          <Alert type="error">There was an error loading dealer codes</Alert>
        )}
        <SearchInput
          id="dealer-code-type"
          name="dealerCodeType"
          options={
            dealercodesTypeList?.map(dealerCodeType => ({
              label: dealerCodeType,
              id: dealerCodeType
            })) || []
          }
          placeholder="Dealer Code Type"
          onChange={event => {
            const selectedItem = event.target.value;
            const selectedValue =
              selectedItem && selectedItem.id ? selectedItem.id : "";
            setSelectedType(selectedValue);
          }}
          onClearCallback={() => setSelectedType("")}
        />
        <TextInput
          id="dealer-code-value"
          label="Dealer Code Value"
          name="dealerCodeValue"
          value={addDealerCodeToDealerInputString?.toString()}
          onChange={e => {
            setAddDealerCodeToDealerInputString(e.target.value);
          }}
        />
        <DuplicateDealerCodeValueWarning
          currentAccountId={accountId}
          dealerCodeVType={selectedType}
          dealerCodeValue={addDealerCodeToDealerInputString}
        />
      </ModalContent>
    </Modal>
  );
};
